export default __webpack_public_path__ + "static/media/Asset 5@10x-8.6b26460a.png";